import { PersonalizedSeenFilter } from '@fund-base/types/ai/personalized-recommended.enum';
import { FundTypeEnum } from '@fund-base/types/funds/funds.types';

export const PERSONALIZED_RECOMMENDED_PAGE_SIZE = 10;

export const PERSONALIZED_SEEN_FILTER_OPTIONS: PersonalizedSeenFilter[] = [
  PersonalizedSeenFilter.Seen,
  PersonalizedSeenFilter.Unseen,
  PersonalizedSeenFilter.All,
];

export interface RecommendedFundTypeOption {
  label: string;
  value: number | null;
}

export const RECOMMENDED_FUND_TYPE_OPTIONS: RecommendedFundTypeOption[] = [
  { label: 'All funding sources', value: null },
  { label: 'Foundation', value: FundTypeEnum.foundation },
  { label: 'Corporation', value: FundTypeEnum.corporation },
  { label: 'Government Grants', value: FundTypeEnum.goverment },
  { label: 'Endowment', value: FundTypeEnum.endowment },
];
